module.exports = __webpack_public_path__ + "img/gr_end_btn.cd240afd.png";